import { memo, useState } from 'react';
import { sortBy } from 'lodash';

import type { TopicFormValues, TopicType } from './Topics.types.ts';

import Topics from './Topics';
import { useService } from './Topics.hooks.ts';

export const TopicsContainer = () => {
  const [selectedTopicKeys, setSelectedTopicKeys] = useState<string[]>([]);
  const [openTopicDrawer, setOpenTopicDrawer] = useState<boolean>(false);
  const [topicId, setTopicId] = useState<string | null>(null);
  const { topics, isLoading, createMutation, updateMutation, deleteMutation } = useService({
    topicId,
  });

  const topicsList = sortBy(
    topics?.map((topic: TopicType) => ({ ...topic, isSelected: false, key: topic.id })),
    'order',
  );

  const handleOpenTopicDrawer = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    id: string | null,
  ) => {
    if (event) event.preventDefault();
    if (id === undefined) return;

    setTopicId(id);
    setOpenTopicDrawer(true);
  };

  const handleCloseTopicDrawer = () => {
    setTopicId(null);
    setOpenTopicDrawer(false);
  };

  const handleSubmitTopic = (values: TopicFormValues) => {
    const data = {
      name: values.name,
      order: values.order,
      type: values.type,
      parentTopicId: values.parentTopicId,
    };
    if (values?.id) {
      updateMutation.mutate({ data: { ...data, id: values.id } });
      handleCloseTopicDrawer();
      return;
    }
    createMutation.mutate(data);
    handleCloseTopicDrawer();
  };

  const handleDeleteTopics = () => {
    const params = { ids: selectedTopicKeys.map((key: string) => key) };
    setTopicId(null);
    setSelectedTopicKeys([]);
    deleteMutation.mutate(params);
  };

  return (
    <Topics
      topics={topicsList}
      isLoading={isLoading}
      openTopicDrawer={openTopicDrawer}
      onOpenTopicDrawer={handleOpenTopicDrawer}
      onCloseTopicDrawer={handleCloseTopicDrawer}
      onSubmitTopic={handleSubmitTopic}
      selectedTopicKeys={selectedTopicKeys}
      setSelectedTopicKeys={setSelectedTopicKeys}
      onDeleteTopics={handleDeleteTopics}
      topicId={topicId}
      itemsToDeleteCount={selectedTopicKeys.length}
    />
  );
};

export default memo(TopicsContainer);
